import { render, staticRenderFns } from "./TournamentSummary.vue?vue&type=template&id=1a412a2f&scoped=true"
import script from "./TournamentSummary.vue?vue&type=script&lang=js"
export * from "./TournamentSummary.vue?vue&type=script&lang=js"
import style0 from "./TournamentSummary.vue?vue&type=style&index=0&id=1a412a2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a412a2f",
  null
  
)

export default component.exports